import React, { useState } from 'react';
import LinkButton from '../Button/LinkButton';
import { useAppContext } from '../../Services/AppContext';
import NetteApiClient from '../../Services/NetteApiClient';
import { Theme } from '../../Enums/Theme.enum';
import useMeddiApp from '../../Hooks/useMeddiApp';
import CaseCloseComponentModal from '../../Modules/Case/Components/CaseCloseComponentModal';

export enum CLOSE_CASE_TYPE {
	FROM_LIST = 'from_list',
	FROM_CASE = 'from_case',
}

interface CloseCaseButtonProps {
	className?: string;
	caseId: string;
	patientId: string;
	type: CLOSE_CASE_TYPE;
	onCaseClose?: () => void;
}

const CloseCaseButton: React.FC<CloseCaseButtonProps> = ({
	caseId,
	patientId,
	onCaseClose,
	type,
}) => {
	const [opened, setOpened] = useState(false);
	const { redirectCaseList } = useAppContext();
	const { isCallActive, hangUpCall } = useMeddiApp();

	const handleAfterCaseClose = () => {
		setOpened(false);
		if (isCallActive()) {
			hangUpCall();
		}

		onCaseClose?.();

		if (redirectCaseList) {
			NetteApiClient.get(redirectCaseList);
		}
	};

	return (
		<>
			<LinkButton
				onClick={() => setOpened(true)}
				title='base.shared.closeCase'
				theme={Theme.RED}
				firstUpper
			/>
			<CaseCloseComponentModal
				caseId={caseId}
				patientId={patientId}
				opened={opened}
				onClose={() => setOpened(false)}
				onCaseClose={handleAfterCaseClose}
			/>
		</>
	);
};

export default CloseCaseButton;
